import Vue from 'vue'
import App from './App.vue'
import '@/views/attainment/utils/animate'
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1,
  attempt: 1
});
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
